import { useEffect, useState } from "react";
import { api, API } from "@/lib/api";
import { PageHeader, Btn, Field, Select } from "@/components/UI";
import { FileXls, FilePdf, DownloadSimple } from "@phosphor-icons/react";

export default function Export() {
  const [filiere, setFiliere] = useState([]);
  const [sel, setSel] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => { api.get("/filiere").then((r) => setFiliere(r.data)); }, []);

  const download = async (kind) => {
    setBusy(true);
    try {
      const res = await api.get(`/export/${kind}`, {
        params: sel ? { filiera_id: sel } : {},
        responseType: "blob",
      });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = kind === "excel" ? "rendicontazione.xlsx" : "report.pdf";
      a.click();
      URL.revokeObjectURL(url);
    } finally { setBusy(false); }
  };

  return (
    <div className="fade-in" data-testid="export-page">
      <PageHeader eyebrow="Document Center" title="Esportazione Rendicontazione" />
      <div className="p-8 space-y-6">
        <div className="bg-white border border-slate-200 rounded-md p-6 max-w-2xl">
          <div className="eyebrow mb-4">Ambito export</div>
          <Field label="Filiera (facoltativo)">
            <Select value={sel} onChange={(e) => setSel(e.target.value)} data-testid="export-filiera">
              <option value="">Tutte le filiere</option>
              {filiere.map((f) => <option key={f.id} value={f.id}>{f.nome}</option>)}
            </Select>
          </Field>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-2xl">
          <div className="bg-white border border-slate-200 rounded-md p-6">
            <div className="w-12 h-12 rounded-md bg-emerald-100 text-emerald-700 flex items-center justify-center mb-4">
              <FileXls size={26} weight="duotone" />
            </div>
            <h3 className="font-bold text-slate-900 mb-1" style={{ fontFamily: "Chivo" }}>Excel rendicontazione</h3>
            <p className="text-xs text-slate-500 mb-4">30 colonne: investimenti, fatture, bonifici, CUP, CIG, dicitura PNRR, esito controlli.</p>
            <Btn variant="primary" onClick={() => download("excel")} disabled={busy} data-testid="export-excel-btn">
              <DownloadSimple size={16} weight="bold" /> Scarica Excel
            </Btn>
          </div>

          <div className="bg-white border border-slate-200 rounded-md p-6">
            <div className="w-12 h-12 rounded-md bg-red-100 text-red-700 flex items-center justify-center mb-4">
              <FilePdf size={26} weight="duotone" />
            </div>
            <h3 className="font-bold text-slate-900 mb-1" style={{ fontFamily: "Chivo" }}>Report PDF</h3>
            <p className="text-xs text-slate-500 mb-4">Report sintetico: KPI di avanzamento e elenco fatture in formato professionale.</p>
            <Btn variant="primary" onClick={() => download("pdf")} disabled={busy} data-testid="export-pdf-btn">
              <DownloadSimple size={16} weight="bold" /> Scarica PDF
            </Btn>
          </div>
        </div>
      </div>
    </div>
  );
}
